<template>
    <div class="card-container">
        <common-top-form :model="formModel" @openAddDialog="changeNote" :submitService="submitService"
                         :submitData="submitData" @success="onSuccess" addShowPower="/sysMsg/create">
            <select-organs v-model="formModel.tatSimpleId"></select-organs>
            <!--<el-form-item label="通知内容">-->
            <!--<el-input v-model="formModel.messageContent" maxlength="50" placeholder="请输入通知内容"></el-input>-->
            <!--</el-form-item>-->
            <el-form-item label="创建时间">
                <el-date-picker
                    v-model="formModel.time"
                    type="daterange"
                    range-separator="至"
                    :clearable="true"
                    value-format="yyyy-MM-dd"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="messageContent" label="详情" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="160">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetail(scope.row)">详情</el-button>
                    <el-button  type="text" @click="handleChange(scope.row.id)" class="button-color"  v-if="hasPerm('/sysMsg/delete')">删除</el-button>
                </template>
            </el-table-column>
        </common-table>
        <form-dialog ref="formDialog" :formDialogTitle="formDialogTitle" :model="dialogModel" labelWidth="110px"
                     :dialogService="dialogService" :submitData="dialogData" :rules="dialogRules" class="over addNotice"
                     @success="dialogSuccess" @close="dialogClose">
            <el-form-item label="消息内容" prop="messageContent">
                <el-input type="textarea" maxlength="500" show-word-limit resize="none" rows="5"
                          v-model="dialogModel.messageContent" :disabled="disabled" placeholder="请输入消息标题"></el-input>
            </el-form-item>
            <el-form-item label="机构简称" prop="allFlag">
                <el-checkbox :indeterminate="isIndeterminate" v-model="dialogModel.allFlag" :disabled="disabled" @change="handleCheckAllChange" :true-label="1" :false-label="0">全选</el-checkbox>
                <el-checkbox-group v-model="dialogModel.tatIds" @change="handleCheckedCitiesChange"  :disabled="disabled">
                    <el-checkbox v-for="(item, index) in tatSimpleNames" :label="item.id" :key="item.id">{{item.simpleName}}</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </form-dialog>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import SelectOrgans from 'components/business/SelectOrgans'
    import FormDialog from '../../dialog/FormDialog'

    import TimeRange from 'service/constant/TimeRange'
    import OrganService from 'service/OrganService'
    import APPService from 'service/APPService'
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "indexnoticemanage",
        data() {
            return {
                formModel: {
                    tatSimpleId: '',
                    time: TimeRange.monthRange
                },
                tableData: [],
                tatIds: [],
                submitService: APPService.tatMessageSettingList,
                page: {},
                formDialogTitle: '',
                dialogModel: {
                    tatIds: [],
                    messageContent: '',
                    allFlag: 0,
                },
                dialogRules: {
                    messageContent: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            if (!value || value.trim() == '') {
                                callback(new Error('请输入消息内容'))
                            } else {
                                callback()
                            }
                        },
                    }],
                },
                isPage: false,
                disabled:false,
                noticeId:'',
                isIndeterminate: true,
                dialogService: null
            }
        },
        mixins: [loadMixin, dialogMixin],
        components: {
            SelectOrgans,
            CommonTopForm,
            CommonTable,
            FormDialog
        },
        computed: {
            dialogData() {
                const params = {
                    userId: this.userId,
                    allFlag: this.dialogModel.allFlag,
                    tatIds: this.dialogModel.tatIds,
                    messageContent: this.dialogModel.messageContent.trim(),
                };
                if (this.noticeId) {
                    params.id = this.noticeId
                }
                params[this.noticeId ? 'updateUser' : 'createUser'] = this.userId;
                return params;
            },
            submitData() {
                if (this.formModel.time == null || this.formModel.time == '') {
                    this.formModel.time = [];
                }
                this.params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                if (this.formModel.time.length) {
                    this.params.startDate = this.formModel.time[0];
                    this.params.endDate = this.formModel.time[1];
                }

                return this.params;
            },
            ...mapGetters(['userId', 'tatSimpleNames'])
        },
        mounted() {
            this.page = this.$refs.commonTable.page;
            this.getList();
        },
        methods: {
            handleCheckAllChange(val) {
                if (val) {
                    this.tatSimpleNames.forEach(item => {
                        this.tatIds.push(item.id)
                    });
                }
                this.$nextTick(()=>{
                    this.dialogModel.tatIds = val ? this.tatIds : [];
                    this.isIndeterminate = false;
                })
            },
            handleCheckedCitiesChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.tatSimpleNames.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.tatSimpleNames.length;
            },
            getPage() {
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService, this.submitData, res => {
                    this.doCheck(res, res => {
                        this.onSuccess(res);
                        this.isPage = false;
                    });
                }, '信息获取失败')
            },
            onSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.tableData = result.rows;

                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                });
            },
            changeNote(id) {
                this.noticeId = id;
                this.dialogService = this.noticeId ?  APPService.tatMessageSettingEdit : APPService.tatMessageSettingAdd;
                this.formDialogTitle =  this.noticeId ? '新建通知': '修改通知';
                this.$refs.formDialog.open();
            },
            dialogSuccess(res) {
                this.doCheck(res, res => {
                    const result = res.contents;
                    this.showSuccess(result.optMsg);
                    this.getList();
                    this.$refs.formDialog.closeDialog();
                });

            },
            dialogClose() {
                this.disabled = false;
                this.isIndeterminate= true;
                this.dialogModel = {
                    tatIds: [],
                    messageContent: '',
                    allFlag: 0,
                };
                this.tatIds = [];
            },
            handleDetail(item){
                this.disabled = true;
                this.getDetail(item);
                this.changeNote(item.id);
            },
            getDetail(item){
                this.dialogModel = JSON.parse(JSON.stringify(item));
                this.dialogModel.tatIds = this.dialogModel.tatIds.split(',');
                this.isIndeterminate = this.dialogModel.tatIds.length != this.tatSimpleNames.length;
            },
            doDelete(id) {
                const deleteParams = {
                    id: id,
                };

                this.doLoad(APPService.tatMessageSettingDel, deleteParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                })
            },
            doStatus(id, type) {
                const deleteParams = {
                    id: id,
                    value: type == 1 ? 0 : 1
                };

                this.doLoad(APPService.sysMsgEnable, deleteParams, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.showSuccess(result.optMsg);
                        this.getList();
                    });
                })
            },
            handleChange(id) {
                this.showConfirm('确定删除该通知').then(() => {
                    this.doDelete(id)
                }).catch(() => {
                });
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/IndexNoticeManage.vue